import { AccommodationPlaceV2Fragment, AccommodationRoomBlockFragment, TravelDistancesBetweenPointsResponseFragment } from '@graphql/generated';

export enum TravelMapBlockType {
  travelMapAccommodationsCustom = 'travelMapAccommodationsCustom',
  travelMapAccommodationsHotel = 'travelMapAccommodationsHotel',
  travelMapAccommodationsRoomblock = 'travelMapAccommodationsRoomblock',
  travelMapVenue = 'travelMapVenue',
}

export type CustomPropertyType = AccommodationPlaceV2Fragment;

export type HotelType = AccommodationPlaceV2Fragment;

export type Venue = Readonly<{
  [key: string]: unknown;
  address?: string | null;
  googlePlaceId?: string | null;
  id?: string;
  latitude?: number | null;
  locationValue?: string;
  longitude?: number | null;
  name?: string | null;
  pointOnMapId?: string | null;
  postalCode?: string | null;
}>;

export type VenueType = Venue;

export interface ReservedRoomBlocks
  extends Readonly<{
    address?: string | null;
    bookingUrl?: string | null;
    checkInDate?: string | null;
    checkOutDate?: string | null;
    cutoffDate?: string | null;
    displayName?: string | null;
    hotelMoreInfoUrl?: string | null;
    id?: string;
    isFavorite?: boolean | null;
    note?: string | null;
    numberOfRoomsReserved?: number | null;
    photo?: { __typename?: 'Photo'; url: string } | null;
    pricePerNight?: number | null;
    starRating?: number | null;
    strikeoutPricePerNight?: number | null;
  }> {}

export type RoomBlocksType = ReservedRoomBlocks;

export interface AccommodationItemList
  extends Readonly<{
    address?: string | null;
    createdByType?: string;
    cutoffDate?: string | null;
    description?: string | null;
    distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;
    displayName?: string | null;
    distance?: number | null;
    id: string;
    isFavorite?: boolean | null;
    isFromAccommodationCatalog?: boolean;
    isJoyManagedRoomBlock: boolean;
    isPhotoHidden?: boolean;
    joyPlaceId?: string | null;
    lat?: number | null;
    lng?: number | null;
    numberOfRoomsReserved?: number | null;
    phone?: string | null;
    photoUrl?: string | null;
    placeId?: string | null;
    price?: number | null;
    rating?: number | null;
    strikeoutPrice?: number | null;
    type: TravelMapBlockType;
    websiteUrl?: string;
  }> {}

export interface AccommodationCard
  extends Readonly<{
    accommodationRoomBlock?: AccommodationRoomBlockFragment;
    address?: string | null;
    checkInDate?: string | null;
    checkOutDate?: string | null;
    createdByType?: string;
    currency?: string;
    cutoffDate?: string | null;
    customPhone?: string | null;
    description?: string | null;
    distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;
    displayName?: string | null;
    distance?: number | null;
    id: string;
    isFavorite?: boolean | null;
    isFromAccommodationCatalog?: boolean;
    isJoyManagedRoomBlock: boolean;
    isPhotoHidden?: boolean;
    joyPlaceId?: string | null;
    lat?: number | null;
    lng?: number | null;
    numberOfRoomsReserved?: number | null;
    phone?: string | null;
    photoUrl?: string | null;
    placeId?: string | null;
    price?: number | null;
    rating?: number | null;
    starRating?: number | null;
    strikeoutPrice?: number | null;
    type: TravelMapBlockType;
    websiteUrl?: string;
  }> {}

export interface HotelRoomBlock
  extends Readonly<{
    bookingUrl?: string | null;
    checkInDate?: Date | null;
    checkOutDate?: Date | null;
    cutoffDate?: Date | null;
    isJoyManagedRoomBlock?: boolean;
    numberOfRoomsReserved?: number | null;
    photoUrl?: string | null;
    pricePerNight?: number | null;
    strikeoutPricePerNight?: number | null;
  }> {}
